import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PartnerPreviewResponse } from '../../api/client.service';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'san-zustimmung-partner',
  templateUrl: './zustimmung-partner.component.html',
  styleUrls: ['./zustimmung-partner.component.scss'],
  standalone: false,
})
export class ZustimmungPartnerComponent implements OnInit {
  @Input() token!: string;
  @Input() pin!: string;
  @Input() state!: PartnerPreviewResponse;
  @Input() sending = false;

  @Output() bestaetigenClicked = new EventEmitter<void>();

  spinnerIcon = faSpinner;

  bed1 = false;
  bed2 = false;

  constructor() {}

  ngOnInit(): void {}

  onBestaetigenClicked() {
    if (this.sending || !this.bed1 || !this.bed2) {
      return;
    }
    this.bestaetigenClicked.emit();
  }
}
